import { render } from "./DashboardChart.vue?vue&type=template&id=3be45962&scoped=true"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"

import "./DashboardChart.vue?vue&type=style&index=0&id=3be45962&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be45962"]])

export default __exports__